/**
 * @file Performance Data
 */
import {
  noneFormatter,
  percentCellFormatter,
  integerValueFormatter,
  moneyFormatterWithUnit,
} from 'src/const/statistics/formatters';
import { isGrossImpressionMetricsWhite } from 'src/const/whiteList';
import { COLUMN_WIDTH } from 'src/const/column-width';

/**
 * 每项对应的字段
 * {
 *    key: 对应的后端字段
 *    i18nPath: title 文案对应的 key
 *    hint:
 *    hoverKey: 用于表头hover内容，绝大部分列的类型可以由key计算得来，特殊的列需要写死
 *    min-width: 最小宽度
 *    sortable: 是否可排序
 *    currency: ？？存在的意义是什么。发现没用先删掉了
 *    align: 对齐方向
 *    header-align: header 对齐方向
 *    formatter(Option): 数据格式化函数
 * }
 */
export const EnumCommonData = [
  {
    i18nPath: 'common_total_cost', // 总消耗
    key: 'stat_cost',
    hint: 'campaign_hover_stat_data.stat_cost',
    hoverKey: 'report_info_hover_data_report_dimensions_index_stat_cost',
    'min-width': COLUMN_WIDTH.L,
    sortable: true,
    align: 'right',
    'header-align': 'right',
    formatter: moneyFormatterWithUnit, // 格式化具体展示数据，千分位分隔+币种精度
  },
  {
    i18nPath: 'common_CPC', // cpc
    key: 'cpc',
    hint: 'campaign_hover_stat_data.click_cost',
    hoverKey: 'report_info_hover_common_CPC',
    'min-width': COLUMN_WIDTH.M,
    sortable: true,
    align: 'right',
    'header-align': 'right',
    formatter: moneyFormatterWithUnit,
  },
  {
    i18nPath: 'common_CPM', // cpm
    key: 'cpm',
    hint: 'campaign_hover_stat_data.cpm',
    hoverKey: 'report_info_hover_common_cpm',
    'min-width': COLUMN_WIDTH.M,
    sortable: true,
    align: 'right',
    'header-align': 'right',
    formatter: moneyFormatterWithUnit,
  },
  {
    i18nPath: 'list_total_impression', // 展示数
    hint: 'campaign_hover_stat_data.show_cnt',
    key: 'show_cnt',
    'min-width': COLUMN_WIDTH.M,
    sortable: true,
    formatter: integerValueFormatter, // 单元格数据格式化
  },
  {
    i18nPath: 'common_gross_show_cnt', // 总展示数
    hint: 'campaign_hover_stat_data.gross_show_cnt',
    hoverKey: 'campaign_hover_stat_data.gross_show_cnt',
    key: 'gross_show_count',
    'min-width': COLUMN_WIDTH.M,
    sortable: true,
    hide: () => !isGrossImpressionMetricsWhite(), // R&F 白名单可见
    formatter: integerValueFormatter, // 单元格数据格式化
  },
  {
    i18nPath: 'list_total_click', // 点击数
    hint: 'campaign_hover_stat_data.click_cnt',
    key: 'click_cnt',
    'min-width': COLUMN_WIDTH.S,
    sortable: true,
    formatter: integerValueFormatter,
  },
  {
    i18nPath: 'common_CTR', // 点击率
    hint: 'campaign_hover_stat_data.ctr',
    key: 'ctr',
    'min-width': COLUMN_WIDTH.S,
    sortable: true,
    formatter: percentCellFormatter,
  },
  {
    i18nPath: 'list_video_show_uv', // 总覆盖UV
    hint: 'campaign_hover_stat_data.show_uv',
    disabledText: 'campaign_hover_stat_data.show_uv.disabled',
    key: 'show_uv',
    sortable: true,
    formatter: integerValueFormatter,
  },
  {
    i18nPath: 'list_video_cost_per_show_uv_mille', // 覆盖千人成本
    hint: 'campaign_hover_stat_data.cost_per_show_uv_mille',
    disabledText: 'campaign_hover_stat_data.cost_per_show_uv_mille.disabled',
    key: 'cost_per_show_uv_mille',
    sortable: true,
    formatter: moneyFormatterWithUnit,
  },
  {
    i18nPath: 'common_frequency', // frequency
    hint: 'campaign_hover_stat_data.frequency',
    key: 'frequency',
    sortable: true,
    formatter: noneFormatter,
  },
];
